import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import first_order from "./components/first-order";
import second_order from "./components/second-order";
import audibility_test from "./components/audibility-test";
import synthesis from "./components/synthesis";

const principle: Slide = {
  description: "For a simple two dimensional room. image sources up to second order can be visualized and auralized.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [
            { name: "First order" },
            { name: "Second order" },
            { name: "Audibility test" },
            { name: "Synthesis" },
          ],
          options: {},
        },
      ],
      extraContent: [],
      components: [first_order, second_order, audibility_test, synthesis],
    },
  },
};

export default principle;
